import 'slick-carousel';
import '~/js/sections/general/destinations/includes/turks-top-slider';

const expirienceButton = $('.js-expirience-read-more');
const expirienceAdded = $('.js-expirience-added');
let isExpirienceShow = false;

const $carousel = $('#inc-carousel');
const $control = $('#inc-carousel-control');

$('.js-scroll-below').on('click', () => {
  const $main = $('html, body');
  const $heroSection = $('#hero-slider');
  const heroSectionTop = $heroSection.offset().top;
  const heroSectionHeight = $heroSection.outerHeight();
  const headerCollapsedHeight = 34;
  let stickyNavHeight = 0;

  if ($heroSection.hasClass('sticky-nav--enabled')) {
    stickyNavHeight = 80;
  }

  const scrollHere = heroSectionTop + heroSectionHeight - headerCollapsedHeight - stickyNavHeight;

  $main.animate({
    scrollTop: scrollHere
  }, 1000);
});

expirienceButton.on('click', () => {
  isExpirienceShow = !isExpirienceShow;
  if (isExpirienceShow) {
    expirienceAdded.removeClass('hide');
    expirienceButton.children('span').text('read less');
  } else {
    expirienceAdded.addClass('hide');
    expirienceButton.children('span').text('read more');
  }
});


$carousel.slick({
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
});

// Sliders
const slider = $('.js-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<span class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></span>',
  nextArrow: '<span class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></span>'
});

slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});
